// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"QuestionStep-module-descriptionWrapper-h0EDZ","accordionWrapper":"QuestionStep-module-accordionWrapper-23c6h"};